import { Box, withStyles } from '@material-ui/core';

export const MobileCard = withStyles(({ palette }) => ({
  root: {
    padding: 12,
    borderRadius: 20,
    position: 'relative',
    width: '100%',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    backgroundColor: palette.common.white
  }
}))(Box);
